import { verificationQueryKeys as e } from "./useVerificationQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { verificationApi as r } from "@maat/api-main";
//#region src/verification/useDeleteIdentityDocumentMutation.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: r.deleteIdentityDocument,
		onSuccess: () => {
			i.invalidateQueries({ queryKey: e.identity() });
		}
	});
};
//#endregion
export { i as useDeleteIdentityDocumentMutation };
